import getConfig from 'next/config';

export const {
  LOCAL_BFPS,
  CLUSTER,
  ENV,
  SERVICE_NAME,
  RIG_DEPLOYMENT_TYPE,
  SIMULATE_ISLAND,
  site_captcha_key,
  sentry_dsn: sentryDsn,
  abeagle_host: abeagleHost,
  AUTH_DOMAIN,
  AUTH_CLIENT_ID,
} = getConfig().publicRuntimeConfig;

export const ITUNES_APP_URL = 'https://itunes.apple.com/app/id6743228929';

export const VERIFIED_BFISLAND_USERNAME = 'bfisland';

export const FAQ_ITEMS = [
  {
    title: 'What is "Riffing" and how do I start?',
    description:
      'Riffing is the fastest way to turn a photo into a visual inside joke. Take a photo of your friend, your cat, or anything you want, make a change, and start a "riff-chain" that your group chat can keep building on.',
  },
  {
    title: 'How is this different from a standard AI generator?',
    description:
      'Most AI tools feel like you are talking to a boring bot, and that gets old fast. BF Island is a social app where you cook up memes with your friends in real-time. It is faster than ChatGPT and funnier than Snapchat.',
  },
  {
    title: 'Wait, is this environmentally friendly?',
    description:
      'We hear you - the sustainability of AI is a huge concern. We are actively working on programs to offset the water and energy our AI models use and donate to environmental causes. We are all about having fun without trashing the planet.',
  },
  {
    title: 'Can I use this for my college orientation or club?',
    description:
      'You simply must. BF Island is basically built for high-intensity social chaos like orientation or club events where inside jokes happen every five seconds. Take a photo, start a riff, and let your group chat get weird.',
  },
];

export const DEMO_BASE_STEP_IMAGE =
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/m8Fp38soM.png?output-format=jpg&output-quality=95';
export const DEMO_MID_STEP_IMAGE =
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/J7g0d5aN6.png?output-format=jpg&output-quality=95';
export const DEMO_FINAL_STEP_IMAGE =
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/jyQdb3wv1.png?output-format=jpg&output-quality=95';

export const DEMO_VIDEO =
  'https://www.buzzfeed.com/static-assets/isolated/bfislandui-prod-public/store.mp4';
export const GENERATOR_VIDEO =
  'https://www.buzzfeed.com/static-assets/isolated/bfislandui-prod-public/big-thing-generator_compressed.mp4';
export const CHAT_SCREEN_VIDEO =
  'https://www.buzzfeed.com/static-assets/isolated/bfislandui-prod-public/pest.mp4';
export const TRANSFORM_LEFT_IMAGE =
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/S5oq22opB.png?output-format=jpg&output-quality=95';
export const TRANSFORM_RIGHT_IMAGE =
  'https://img.buzzfeed.com/store-an-image-prod-us-east-1/yiK_Z9Jk1.png?output-format=jpg&output-quality=95';
